import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChange
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { ValidatorFn, Validators } from '@angular/forms'

import { CaseInput } from '../../../interfaces/case-input.interface'
import { SelectOption } from '../../../interfaces/select-option.interface'

@Component({
    selector: 'case-multi-checkbox-input',
    templateUrl: './multi-checkbox-input.component.html',
    styleUrls: ['./multi-checkbox-input.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class MultiCheckboxInputComponent implements CaseInput, OnChanges {
  @Input() label: string
  @Input() initialValue: string[] = []
  @Input() selectOptions: SelectOption[]
  @Input() helpText: string
  @Input() htmlHelpText?: string
  @Input() showErrors = false
  @Input() validators: ValidatorFn[] = []
  @Input() required: boolean
  @Input() uniqueId: string
  @Input() readonly: boolean

  @Output() valueChanged: EventEmitter<string[]> = new EventEmitter()

  activeOptions: string[] = []
  showList = false

  optionGroups: { name: string; options: SelectOption[] }[] = []

  constructor(private elementRef: ElementRef, private ngZone: NgZone) {}

  ngOnChanges(changes: { selectOptions?: SimpleChange }) {
    if (this.validators.includes(Validators.required)) {
      this.required = true
    }

    // Reset form value if we change select options.
    if (this.activeOptions.length && changes.selectOptions) {
      return (this.activeOptions = [])
    }

    this.activeOptions = this.initialValue?.map(String) || []

    this.selectOptions.forEach((option) => {
      option.selected = this.activeOptions.includes(String(option.value))
    })

    // Create groups based on subLabel.
    this.optionGroups = this.selectOptions.reduce((acc, option) => {
      const group = acc.find((group) => group.name === option.subLabel)
      if (group) {
        group.options.push(option)
      } else {
        acc.push({ name: option.subLabel, options: [option] })
      }
      return acc
    }, [])
  }

  toggleSelected(option: SelectOption): void {
    if (this.readonly) return

    const clickedOption = String(option.value)

    this.ngZone.run(() => {
      this.handleMultiSelect(option)
    })
  }

  private handleMultiSelect(option: SelectOption): void {
    const clickedOption = String(option.value)
    const index = this.activeOptions.indexOf(clickedOption)
    option.selected = !option.selected
    if (index !== -1) {
      this.activeOptions.splice(index, 1)
    } else {
      this.activeOptions.push(clickedOption)
    }

    this.valueChanged.emit(this.activeOptions)
  }
}
